import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import RaisedButton from 'material-ui/RaisedButton';

import api from 'services';

class SenderTrain extends React.Component {

    render() {
        const { selectedTextToTrain, clearSelectedTextToTrain, selectedType, sendTrain } = this.props;

        return (
            <Fragment>
                <div className='paper-block margin-10'>
                    <span className='name-block absolute small-name'>Sender render</span>

                    {
                        selectedTextToTrain.length > 0
                        ?
                            <div className='paper-block'>
                                {selectedTextToTrain}
                            </div>
                            :
                            ''
                    }

                    <div className="row">
                        <div className="col-xs-3">
                            <RaisedButton
                                label='Clear'
                                onClick={clearSelectedTextToTrain}
                                secondary
                                labelStyle={{ textTransform: 'none', fontSize: '12px' }}
                            />
                        </div>
                        <div className="col-xs-3">
                            <RaisedButton
                                label='Send train'
                                disabled={selectedType === ''}
                                primary
                                onClick={sendTrain}
                                labelStyle={{ textTransform: 'none', fontSize: '12px' }}
                            />
                        </div>
                    </div>
                </div>

                <div className='paper-block margin-10'>
                    <span className='name-block absolute small-name'>Model</span>
                    <div className="row">


                        <div className="col-xs-3">
                            <RaisedButton
                                label='Save'
                                labelStyle={{ textTransform: 'none', fontSize: '12px' }}
                                onClick={api.saveModel}
                                primary
                                disabled
                            />
                        </div>
                        <div className="col-xs-3">
                            <RaisedButton
                                label='Load'
                                onClick={api.loadModel}
                                labelStyle={{ textTransform: 'none', fontSize: '12px' }}
                                primary
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

SenderTrain.propTypes = {

};

export default SenderTrain;


// WEBPACK FOOTER //
// ./app/components/Letters/Single/Train/Sidebar/SenderTrain.jsx